import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles(
  _theme => ({
    cardContainer: {
      marginTop: 16
    },
    cardContentContainer: {
      alignItems: "center",
      display: "flex",
      justifyContent: "space-between",
      padding: "8px 24px",
      paddingBottom: "8px !important"
    },
    radioContainer: {
      alignItems: "center",
      display: "flex"
    },
    styledDisabledButtonText: {
      "&:disabled > span": {
        color: "#C5C5C5 !important"
      }
    },
    styledFormControlLabel: {
      marginRight: "4px"
    }
  }),
  { name: "EnableUnlockCodesCard" }
);
